import { useState, useEffect } from 'react'
import ProductSelector from './ProductSelector'

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  },
  modal: {
    background: '#fff',
    borderRadius: '15px',
    padding: '20px',
    width: '90%',
    maxWidth: '900px',
    maxHeight: '80vh',
    overflow: 'auto',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
  },
  title: {
    fontSize: '20px',
    fontWeight: 'bold',
  },
  closeButton: {
    padding: '8px 15px',
    background: '#666',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
  },
  inputRow: {
    display: 'flex',
    gap: '10px',
    marginBottom: '20px',
    alignItems: 'center',
  },
  saveButton: {
    width: '100%',
    padding: '15px',
    background: '#4CAF50',
    color: '#fff',
    border: 'none',
    borderRadius: '10px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    marginTop: '20px',
  },
}

function ProfileProductsEditor({ profile, products, onSave, onClose }) {
  const [editedProfile, setEditedProfile] = useState({ ...profile })
  const [selectedIds, setSelectedIds] = useState([])
  const [sortOrder, setSortOrder] = useState([])

  useEffect(() => {
    if (profile.produkte) {
      const prodIds = profile.produkte.split(',').filter(x => x.trim())
      setSelectedIds(prodIds.map(id => parseInt(id)))
    }
    if (profile.sortierung) {
      const sortIds = profile.sortierung.split(',').filter(x => x.trim())
      setSortOrder(sortIds.map(id => parseInt(id)))
    }
  }, [profile])

  const handleSave = () => {
    onSave({ ...editedProfile, originalId: profile.id }, selectedIds.join(','), sortOrder.join(','))
    onClose()
  }

  const handleChange = (newSelectedIds, newSortOrder) => {
    setSelectedIds(newSelectedIds)
    setSortOrder(newSortOrder)
  }

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={e => e.stopPropagation()}>
        <div style={styles.header}>
          <h2 style={styles.title}>Profil bearbeiten</h2>
          <button style={styles.closeButton} onClick={onClose}>✕</button>
        </div>

        <div style={styles.inputRow}>
          <input
            type="text"
            placeholder="ID"
            value={editedProfile.id}
            onChange={(e) => setEditedProfile({ ...editedProfile, id: e.target.value })}
            style={{ padding: '8px', borderRadius: '5px', border: '1px solid #ddd', flex: '0 0 120px' }}
          />
          <input
            type="text"
            placeholder="Name"
            value={editedProfile.name}
            onChange={(e) => setEditedProfile({ ...editedProfile, name: e.target.value })}
            style={{ padding: '8px', borderRadius: '5px', border: '1px solid #ddd', flex: 1 }}
          />
          <input
            type="color"
            value={editedProfile.color}
            onChange={(e) => setEditedProfile({ ...editedProfile, color: e.target.value })}
            style={{ padding: '5px', borderRadius: '5px', border: '1px solid #ddd', flex: '0 0 60px' }}
          />
        </div>

        <ProductSelector
          allProducts={products}
          selectedIds={selectedIds}
          sortOrder={sortOrder}
          onChange={handleChange}
        />

        <button style={styles.saveButton} onClick={handleSave}>
          Speichern
        </button>
      </div>
    </div>
  )
}

export default ProfileProductsEditor